<div class="form-group" [ngClass]="{ required: markAsRequired, valid: markAsValid }">
	<label class="col-form-label" [for]="id">{{ label }}</label>
	<div class="input-field">
		<textarea
			class="form-control"
			[ngClass]="{ 'is-invalid': isInvalid(control) }"
			[maxlength]="maxLength"
			type="text"
			[id]="id"
			[name]="id"
			[rows]="Helper.getPositiveNumber(rows)"
			[formControl]="control"
			[placeholder]="placeholder"
			[tabindex]="tabIndex"
		>
		</textarea>

		<div *ngIf="isInvalid(control)" class="invalid-feedback">
			<small *ngIf="inputErrors(control, 'required')">
				<span>{{ 'error.required' | translate: { fieldName: label ? label : placeholder } }}</span>
			</small>
		</div>
		<small *ngIf="maxLength" class="chars-left">Characters left: {{ charsLeft }}</small>
	</div>
</div>
